export default "__VITE_ASSET__BUSGDyzP__"